/** Qobuz album id for a title/artist when the page has no direct Qobuz id (moved out of AlbumDetailView). */
import { CLOUD_API_URL } from '../config/serverConfig';
import { getHeaders } from '../lib/useQobuz';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export async function searchQobuzAlbumIdByTitle(title: string, artist: string): Promise<string | null> {
  try {
    const q = artist ? `${title} ${artist}` : title;
    const resp = await fetch(
      `${CLOUD_API_URL}/api/streaming/qobuz/search?q=${encodeURIComponent(q)}&limit=5`,
      { headers: getHeaders() },
    );
    if (!resp.ok) return null;
    const data = await resp.json().catch(() => null);
    const albums: any[] = data?.albums || [];
    const normalize = (s: unknown) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const titleNorm = normalize(title);
    const match = albums.find((a) => normalize(a?.title).includes(titleNorm) || titleNorm.includes(normalize(a?.title)));
    const best = match || albums[0];
    const id = String(best?.serviceAlbumId || best?.id || '').replace(/^qobuz:album:/, '').trim();
    return id && !UUID_RE.test(id) ? id : null;
  } catch {
    return null;
  }
}
